import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, of, withLatestFrom, filter } from 'rxjs';
import { ClientService } from '../services/client.service';
import {
  loadClientProfiles,
  loadClientProfilesFailure,
  loadClientProfilesSuccess,
} from './diet.actions';
import { Store } from '@ngrx/store';
import { selectAllClients } from './diet.selectors';

@Injectable()
export class ClientEffects {
  constructor(
    private actions$: Actions,
    private clientService: ClientService,
    private store: Store
  ) {}

  //   loadClients$ = createEffect(() =>
  //     this.actions$.pipe(
  //       ofType(loadClientProfiles),
  //       switchMap(() =>
  //         this.clientService.getClients().pipe(
  //           map((clients) => loadClientProfilesSuccess({ clients })),
  //           catchError((err) =>
  //             of(loadClientProfilesFailure({ error: err.message }))
  //           )
  //         )
  //       )
  //     )
  //   );

  loadClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadClientProfiles),
      withLatestFrom(this.store.select(selectAllClients)),
      filter(
        ([action, clients]) =>
          action.forceRefresh || !clients || clients.length === 0
      ), // ✅ Only if not already loaded
      switchMap(() =>
        this.clientService.getClients().pipe(
          map((clients) => loadClientProfilesSuccess({ clients })),
          catchError((error) => of(loadClientProfilesFailure({ error })))
        )
      )
    )
  );
}
